import React, { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { track } from "./lib/track";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Manifesto from "./components/Manifesto";
import Pricing from "./components/Pricing";
import Contact from "./components/Contact";
import WorkShowcase from "./components/WorkShowcase";
import FAQ from "./components/FAQ";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#050505] text-white flex items-center justify-center font-mono text-sm">
          Something went wrong.
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  useEffect(() => {
    track("view", "page");
    const onClick = (e) => {
      const el = e.target && e.target.closest ? e.target.closest("[data-testid]") : null;
      if (el) track("click", el.getAttribute("data-testid"));
    };
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);

  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = undefined;
    };
  }, []);

  return (
    <ErrorBoundary>
      <div className="relative min-h-screen bg-[#050505] text-white overflow-x-clip">
        <div className="grain" aria-hidden="true" />
        <Nav />
        <main>
          <Hero />
          <Marquee />
          <Manifesto />
          <WorkShowcase />
          <Pricing />
          <FAQ />
          <Contact />
        </main>
      </div>
    </ErrorBoundary>
  );
}

export default App;